import { Temporal } from "@js-temporal/polyfill";
import { instantDateTime } from "../schemas/common";
import { BLOCKING_BOOKING_STATUSES, bookingBlocks, type BlockingBooking } from "./schedule";

/** A stale auxiliary flag must not replace a booked/cancelled lifecycle label. */
export function bookingHasEffectiveHold(record: BlockingBooking, now: string | Date): boolean {
  return record.status !== "cancelled" && !BLOCKING_BOOKING_STATUSES.some(status => status === record.status)
    && record.holdStatus === "confirmed" && bookingBlocks(record, now);
}

/** Read-only freshness hint, not a reservation decision. Invalid/unknown expiry
 * stays protected by bookingBlocks and cannot schedule a guessed release. */
export function nextFutureExpiry(values: readonly unknown[], now: string): string | null {
  if (!instantDateTime.safeParse(now).success) return null;
  return earliestExpiry(values.filter(value => instantDateTime.safeParse(value).success && Temporal.Instant.compare(value as string, now) > 0));
}

/** Aggregate already-evaluated server hints without discarding an expiry that
 * crossed while a later chunk was in flight. The client must recheck it once. */
export function earliestExpiry(values: readonly unknown[]): string | null {
  let next: string | null = null;
  for (const value of values) {
    if (!instantDateTime.safeParse(value).success) continue;
    const expiry = value as string;
    if (next === null || Temporal.Instant.compare(expiry, next) < 0) next = expiry;
  }
  return next;
}

export function nextHoldExpiry(records: readonly BlockingBooking[], now: string): string | null {
  return nextFutureExpiry(records.filter(record => record.status !== "cancelled"
    && !BLOCKING_BOOKING_STATUSES.some(status => status === record.status)
    && record.holdStatus === "confirmed").map(record => record.holdExpiresAt), now);
}
